<div class="order-details_info-block">
  <quote-details
    [securityKey]="security || widget.implementationInstance.settings.securityKey">
  </quote-details>
  <div class="order-details_account-info">
    @if (!isAsecurity) {
      <div class="order-details_account-info_algo-type">
        <label class="order-details_account-info_algo-type_label" #algoTypeLabelEl>{{'enums.order-algo-type.label' | l10n}}</label>
        <div class="order-details_account-info_algo-type_value">
          <select-input
            [formControl]="orderForm.controls.algoType"
            [selectMenuItems]="algoTypeMenu"
            [labelElement]="algoTypeLabelEl">
          </select-input>
        </div>
      </div>
    }
    @if (!isSmartSecurity && !isAsecurity) {
      <div class="order-details_account-info_account-select"
        [class.-small]="widget.implementationInstance.isLeverageSelectEnabled$.value">
        <label class="order-details_account-info_account-select_label">{{'components.widgets.trade-widget.account' | l10n}}</label>
        <div class="order-details_account-info_account-select_value">
          <select-account
            [formControl]="orderForm.controls.accountBase"
            [securityKey]="widget.implementationInstance.settings.securityKey">
          </select-account>
        </div>
      </div>
    }
    @if (widget.implementationInstance.isLeverageSelectEnabled$.value) {
      <div class="order-details_account-info_leverage -small">
        <label class="order-details_account-info_leverage_label" #leverageLabel>{{'components.leverage.leverage_label' | l10n}}</label>
        <leverage-select
          [formControl]="orderForm.controls.side.value === Side.BUY ? orderForm.controls.buyLeverage : orderForm.controls.sellLeverage"
          [securityKey]="security"
          [side]="orderForm.controls.side.value"
          [labelElement]="leverageLabel">
        </leverage-select>
      </div>
    }
    <!-- Not used in HG -->
    <!--<div class="order-details_account-info_available-balance" [class.-small]="widget.implementationInstance.isLeverageSelectEnabled$.value" *ngIf="security && !isAsecurity">
    <label class="order-details_account-info_available-balance_label">{{'components.widgets.trade-widget.available_balance' | l10n}}</label>
    <div class="order-details_account-info_available-balance_value">
      <order-available-balance
        [accountId]="widget.implementationInstance.settings.accountId"
        [securityKey]="widget.implementationInstance.settings.securityKey"
        [orderForm]="orderForm">
      </order-available-balance>
    </div>
  </div>-->
  @if (isAsecurity) {
    <asecurity-accounts-map
      [formControl]="orderForm.controls.legsAccountDict"
      [security]="security"
      [side]="orderForm.controls.side.value"
      [qty]="orderForm.controls.quantity.value"
      (onMaxShowTpl)="maxShowTpl = $event"
      (onMaxUnfilledTpl)="maxUnfilledTpl = $event">
    </asecurity-accounts-map>
  }
</div>
@if (isInvPortfoliosAvailable) {
  <div class="order-details_portfolio-info">
    <div class="order-details_portfolio-info_inv-entity">
      <label class="order-details_portfolio-info_inv-entity_label" #investmentEntityLabel>
        {{'components.investment-portfolio.investment_entity_label' | l10n}}
      </label>
      <div class="order-details_portfolio-info_inv-entity_value">
        <inv-entity-id-select
          [formControl]="orderForm.controls.investmentEntityId"
          [labelElement]="investmentEntityLabel">
        </inv-entity-id-select>
      </div>
    </div>
    <div class="order-details_portfolio-info_portfolio">
      <label class="order-details_portfolio-info_portfolio_label" #subPortfolioLabel>
        {{'components.investment-portfolio.portfolio_label' | l10n}}
      </label>
      <div class="order-details_portfolio-info_portfolio_value">
        <portfolio-id-select
          [formControl]="orderForm.controls.portfolioId"
          [invEntityId]="orderForm.controls.investmentEntityId.value"
          [labelElement]="subPortfolioLabel">
        </portfolio-id-select>
      </div>
    </div>
  </div>
}
<div class="order-details_order-info">
  <div class="order-details_exec-price">
    <div class="order-details_label">{{'components.widgets.order-details-widget.exec_price' | l10n}}</div>
    <div class="order-details_value {{ orderInfoExecPrice?.class }}" [innerHTML]="orderInfoExecPrice?.value || ''"></div>
  </div>
  <div class="order-details_status">
    <div class="order-details_label">{{'components.widgets.order-details-widget.status' | l10n}}</div>
    <div class="order-details_value">
      @if (orderInfoStatus) {
        <svg class="order-details_value_status-icon">
          <use [attr.xlink:href]="'#order-' + orderInfoStatus?.icon"></use>
        </svg>
      }
      {{$safeNavigationMigration(orderInfoStatus?.label) | l10n}}
    </div>
  </div>
  <div class="order-details_created-on">
    <div>
      <div class="order-details_label">{{'components.widgets.order-details-widget.created_on' | l10n}}</div>
      <div class="order-details_value" [innerHTML]="orderInfoCreatedOn || ''"></div>
    </div>
  </div>
</div>
<div class="order-details_progress-bar">
  <order-exec-qty-bar
    class="order-details_progress-bar-inner"
    [execQtyWithMultiCurrency]="execQtyWithMultiCurrency">
  </order-exec-qty-bar>
</div>
@if (isOrderRejected) {
  <div class="order-details_reject-reason">
    <div class="order-details_label">{{'components.widgets.order-details-widget.reject_reason_label' | l10n}}</div>
    <div class="order-details_value" textHiding [tooltip]="rejectionReason$ | async">
      <span [innerHTML]="(rejectionReason$ | async) || ''"></span>
    </div>
  </div>
}
</div>

<order-form-block
  [orderForm]="orderForm"
  [orderLeavesQty]="orderLeavesQty"
  [security]="security"
  [isActionsDisabled]="isActionsDisabled"
  [isActionsUnavailable]="isOrderRejected"
  [isReplaceDisabled]="isReplaceDisabled"
  [isOrderInited$]="isOrderInited$"
  [maxShowTpl]="maxShowTpl"
  [maxUnfilledTpl]="maxUnfilledTpl"
  (onSubmit)="goToConfirmation($event)">
</order-form-block>

<ng-container #confirmModalAnchor></ng-container>
